const mockedWorldData = [
  { name: 'groceries', value: '200' },
  { name: 'transportation', value: '50' },
  { name: 'entertainment - hobbies', value: '70' },
  { name: 'fitness - sports', value: '30' },
  { name: 'vacations - trips', value: '100' },
  { name: 'clothes - shoes', value: '50' },
  { name: 'miscellaneous', value: '65' },
];

export default mockedWorldData;
